import React, { useEffect, useState } from 'react';
import { ClockClockwiseIcon, RobotIcon, ChatCircleDotsIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { getRecentItems } from 'helpers/recentItems';

export default function RecentItems() {

    const [ recentItems, setRecentItems ] = useState([]);

    useEffect(() => {
        setRecentItems(getRecentItems());
    }, []);

    const navigate = useNavigate();

    if (!recentItems || recentItems.length === 0) {
        return null;
    }

    const handleClick = (item) => {
        if(item.type === 'agent') {
            return navigate(`/agents/${item._id}`);
        }
        return navigate(`/conversations?${item.type}=${item._id}`);
    };

    return (
        <div className='mb-8'>
            <div className='flex items-center gap-2 mb-4'>
                <ClockClockwiseIcon size={20} className='text-black/60' />
                <h2 className='text-xl font-medium text-black/80'>Recenti</h2>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                {recentItems.map((item) => (
                    <button
                        key={`${item.type}-${item.id}`}
                        onClick={() => handleClick(item)}
                        className='flex items-center gap-3 p-4 bg-white border border-greylight rounded-lg hover:border-grey hover:shadow-sm transition-all duration-200 text-left'
                    >
                        <div className='flex-shrink-0'>
                            {item.type === 'assistant' ? (
                                <ChatCircleDotsIcon size={24} className='text-black/70' />
                            ) : (
                                <RobotIcon size={24} className='text-black/70' />
                            )}
                        </div>
                        <div className='flex-1 min-w-0'>
                            <p className='font-medium text-black/80 truncate'>{item.name}</p>
                            <p className='text-sm text-black/50 capitalize'>{item.type === 'assistant' ? 'Assistente' : 'Agente'}</p>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}
